var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)]), _c('div', {
    staticClass: "search-box btns"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 游戏： "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.game_type,
      expression: "condition.game_type"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.condition, "game_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _vm._l(_vm.setting.gameTypes, function (item) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))]);
  })], 2)]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 上 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.time_period,
      expression: "condition.time_period"
    }],
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "请输入"
    },
    domProps: {
      "value": _vm.condition.time_period
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.condition, "time_period", $event.target.value);
      }
    }
  }), _vm._v(" 期 ")]), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("查询中...")] : [_vm._v("查询")]], 2)]), _c('div', {
    staticClass: "task-list"
  }, [_vm._m(0), _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      staticClass: "task-list-item"
    }, [_c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.id) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.user_id) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.tg_id) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.username) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.firstname) + " " + _vm._s(item.lastname) + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.score) + " ")]), _c('div', {
      staticClass: "s url"
    }, [_vm._v(" " + _vm._s(item.adv_click_count) + " ")]), _c('div', {
      staticClass: "s create"
    }, [_vm._v(" " + _vm._s(item.updated_at) + " ")])]);
  })], 2), _c('pop-adv', {
    attrs: {
      "show": _vm.popAdvShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popAdvShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-list-item"
  }, [_c('div', {
    staticClass: "s"
  }, [_vm._v(" ID ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 用户ID ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 电报ID ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 账号 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 昵称 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 积分 ")]), _c('div', {
    staticClass: "s url"
  }, [_vm._v(" 广告点击数 ")]), _c('div', {
    staticClass: "s create"
  }, [_vm._v(" 最后时间 ")])]);
}];
export { render, staticRenderFns };